export default "__VITE_ASSET__UCabdOox__"